import { required } from '@widergy/web-utils/lib/validate';

import { message } from 'utils/stringUtils';

export const accountRadioFields = totalAccounts => ({
  id: 1,
  type: 'Fields::Radio',
  order: 1,
  title: 'Por favor, para continuar con la solicitud de baja debe seleccionar un suministro.',
  key: 'clientNumber',
  field_options:
    totalAccounts &&
    totalAccounts.map((account, index) => ({
      id: index,
      value: account.clientNumber,
      name: `${account.address} - NIS ${account.clientNumber}`,
      order: index
    })),
  validate: [required(message('Translation:fieldRequired'))]
});
